module.exports = __webpack_public_path__ + "static/ios-2fd0da6749dc1b4cbc2295f8b1c5ebee.png";